import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'

const SecondaryProcessingPage = lazy(
  () => import('@/pages/secondary-processing/ui/index'),
)

export const Route = createFileRoute(
  '/_protected/expedition/secondary-processing',
)({
  component: () => (
    <Suspense fallback={<Loader />}>
      <SecondaryProcessingPage />
    </Suspense>
  ),
})
